module.exports = __webpack_public_path__ + "img/all_inclusive.f310d7dc.svg";